import React from "react";

interface Context {
  galleryBasicPrice: Number;
  galleryStandardPrice: Number;
  gallerySelectionPrice: Number;
  priceList: Array<object> | null;
  galleryCollectionPrice: Number;
  galleryRegularPrice: Number;
  finalRegularPrice: Number;
  finalBasicPrice: Number;
  finalStandardPrice: Number;
  finalSelectionPrice: Number;
  finalCollectionPrice: Number;
  shippingPrice: Number;
  expressPrice: Number;
  populatePriceList: (price_list: Array<any>) => void;
  getPricePerDim: (dim_cm: Number) => any;
  getFinalPricing: (
    dim: Number,
    art_type: string,
    collection_moulding: boolean,
    basic_moulding: boolean,
    standard_moulding: boolean,
    selection_moulding: boolean,
    mount: string,
    mat_shape: string,
    mat_top?: number,
    mat_bottom?: number,
    mat_right?: number,
    mat_left?: number,
    glazing_selected?: string
  ) => any;
}

const PriceContext = React.createContext<Context>({
  priceList: null,
  galleryBasicPrice: 0,
  galleryStandardPrice: 0,
  gallerySelectionPrice: 0,
  galleryCollectionPrice: 0,
  galleryRegularPrice: 0,
  finalRegularPrice: 0,
  finalBasicPrice: 0,
  finalStandardPrice: 0,
  finalSelectionPrice: 0,
  finalCollectionPrice: 0,
  shippingPrice: 6,
  expressPrice: 15,
  populatePriceList: () => {},
  getPricePerDim: () => {},
  getFinalPricing: () => {},
});

export default PriceContext;
